import { apiClient } from './api';

export type DiscountType = 'percent' | 'flat';
export type PromotionScope = 'all' | 'category' | 'sku';

export interface Promotion {
  id: number;
  name: string;
  description: string | null;
  discount_type: DiscountType;
  discount_value: number;
  scope: PromotionScope;
  category_id: number | null;
  category_name: string | null;
  sku_id: number | null;
  sku_code: string | null;
  starts_at: string;
  ends_at: string;
  is_active: boolean;
  created_by_user_id: number;
  created_at: string;
  updated_at: string;
}

export interface PromotionInput {
  name: string;
  description?: string;
  discount_type: DiscountType;
  discount_value: number;
  scope: PromotionScope;
  category_id?: number;
  sku_id?: number;
  starts_at: string;
  ends_at: string;
  is_active?: boolean;
}

export async function listPromotions(): Promise<Promotion[]> {
  const raw = await apiClient.get<{ data: Promotion[] }>('/promotions');
  return raw.data ?? (raw as any);
}

export async function getPromotion(id: number | string): Promise<Promotion> {
  return apiClient.get<Promotion>(`/promotions/${id}`);
}

export async function createPromotion(input: PromotionInput): Promise<Promotion> {
  return apiClient.post<Promotion>('/promotions', input);
}

export async function updatePromotion(id: number | string, input: Partial<PromotionInput>): Promise<Promotion> {
  return apiClient.patch<Promotion>(`/promotions/${id}`, input);
}

export async function deletePromotion(id: number | string): Promise<void> {
  await apiClient.delete<void>(`/promotions/${id}`);
}
